import TableExtension from '@tiptap/extension-table'
import TableCellExtension from '@tiptap/extension-table-cell'
import TableHeaerExtension from '@tiptap/extension-table-header'
import TableRowExtension from '@tiptap/extension-table-row'
import { ReactNodeViewRenderer } from '@tiptap/react'

import TableCellNode from '~lib/editor/extensions/table/TableCellNode'
import TableNode from '~lib/editor/extensions/table/TableNode'

export const TableCell = TableCellExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TableCellNode)
  },
})

export const Table = TableExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TableNode)
  },
})

export const TableHeader = TableHeaerExtension.extend({})

export const TableRow = TableRowExtension.extend({})
